<template>
  <v-dialog
    v-model="show"
    max-width="900px"
  >
    <v-card>
      <v-card-title>
        Request For Medical Insurance
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.prevent="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <v-expansion-panels v-model="firstPanel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0">Attached files</v-expansion-panel-header>
            <v-expansion-panel-content>
              Please upload the documents:<br/>
                1. Signed by yourself insurance agreement.<br/>
                2. Payment check.<br/>
                3. Any other related to the transaction document.
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="mb-2">
          <v-col cols="12" md="4" lg="4">
            <v-file-input
              label="Agreement"
              v-model="insuranceAgreementFile.file"
              @change="onInsuranceAgreementFileChange"
              show-size
              counter
              :accept="ALLOWED_FILE_TYPES"
              :rules="[otherAndInsuranceHaveDifferentNames||'Please, don\'t send 2 identical files']"
            ></v-file-input>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-file-input
              label="Payment check"
              v-model="paymentCheckFile.file"
              @change="onPaymentCheckFileChange"
              show-size
              counter
              :accept="ALLOWED_FILE_TYPES"
              :rules="[checkAndInsuranceHaveDifferentNames||'Please, don\'t send 2 identical files']"
            ></v-file-input>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-file-input
              label="Other (optional)"
              v-model="otherFile.file"
              @change="onOtherFileChange"
              show-size
              counter
              :accept="ALLOWED_FILE_TYPES"
              :rules="[otherAndCheckHaveDifferentNames||'Please, don\'t send 2 identical files']"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-expansion-panels v-model="secondPanel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0">Other fields</v-expansion-panel-header>
            <v-expansion-panel-content>
              How much did you pay for the insurance (UAH)?
                Are there some additional details?
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row>
          <v-col cols="12" lg="4" md="4">
            <v-text-field
              v-model="computedAmountSpent"
              class="inputAmount"
              label="Amount spent"
              type="number"
              hint="Enter amount spent (<= 150 USD per year)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" md="8">
            <v-textarea
              v-model="details"
              rows="1"
              label="Details (optional)"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small :disabled="!isRequestReady() || !isRequestAppropriate" @click="sendRequest" color="primary">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ALLOWED_FILE_TYPES } from '@/constants/fileAccept'
import { getApiErrorMessage } from '@/utils/apiError'
import { fileToDataUrl } from '@/utils/fileDataUrl'

export default {
  name: 'MedicalInsuranceRequest',
  props: {
    value: {
      required: true,
      default: false
    }
  },
  data () {
    return {
      isRequestAppropriate: true,
      firstPanel: 0,
      secondPanel: 0,
      ALLOWED_FILE_TYPES,
      insuranceAgreementFile: {
        file: null,
        File_Name: '',
        File_Type: ''
      },
      paymentCheckFile: {
        file: null,
        File_Name: '',
        File_Type: ''
      },
      otherFile: {
        file: null,
        File_Name: null,
        File_Type: null
      },
      amountSpent: null,
      details: null
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        if (this.value) {
          this.clearAll()
          this.isRequestAppropriate = true
        }
      }
    },
    otherAndInsuranceHaveDifferentNames () {
      if (!this.otherFile.File_Name || !this.insuranceAgreementFile.File_Name) {
        return true
      }
      return this.otherFile.File_Name !== this.insuranceAgreementFile.File_Name
    },
    checkAndInsuranceHaveDifferentNames () {
      if (!this.paymentCheckFile.File_Name || !this.insuranceAgreementFile.File_Name) {
        return true
      }
      return this.paymentCheckFile.File_Name !== this.insuranceAgreementFile.File_Name
    },
    otherAndCheckHaveDifferentNames () {
      if (!this.otherFile.File_Name || !this.paymentCheckFile.File_Name) {
        return true
      }
      return this.otherFile.File_Name !== this.paymentCheckFile.File_Name
    },
    user () {
      return this.$store.getters.getUser
    },
    computedAmountSpent: {
      get () {
        return this.amountSpent
      },
      set (val) {
        if (val < 0) {
          this.amountSpent = -val
        } else {
          this.amountSpent = val
        }
      }
    }
  },
  methods: {
    sendRequest () {
      this.isRequestAppropriate = false
      this.axios.post('/api/requests/medical_insurance',
        {
          Creator_ID: this.user.employee_id,
          Agreement_File: this.insuranceAgreementFile,
          Payment_Check_File: this.paymentCheckFile,
          Other_File: this.otherFile,
          Amount_Spent: this.amountSpent,
          Details: this.details
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(() => {
        this.show = false
        this.$store.dispatch('setSuccess', { successMsg: 'Request for medical insurance was made' })
      }).catch(error => {
        this.isRequestAppropriate = true
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    onInsuranceAgreementFileChange (e) {
      this.onFileChange(e, this.insuranceAgreementFile)
    },
    onPaymentCheckFileChange (e) {
      this.onFileChange(e, this.paymentCheckFile)
    },
    onOtherFileChange (e) {
      this.onFileChange(e, this.otherFile)
    },
    async onFileChange (e, file) {
      if (!e) {
        file.file = null
        file.File_Name = ''
        file.File_Type = ''
        return
      }
      try {
        const res = await fileToDataUrl(e)
        file.File_Name = e.name
        file.File_Type = e.type
        if (file.file) {
          file.file.data = res.data
          file.file.base64String = res.base64String
        }
      } catch (error) {
        file.file = null
        file.File_Name = ''
        file.File_Type = ''
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
    },
    isRequestReady () {
      return this.insuranceAgreementFile.file &&
        this.paymentCheckFile.file &&
        this.computedAmountSpent
    },
    clearAll () {
      this.insuranceAgreementFile = {
        file: null,
        File_Name: '',
        File_Type: ''
      }
      this.paymentCheckFile = {
        file: null,
        File_Name: '',
        File_Type: ''
      }
      this.otherFile = {
        file: null,
        File_Name: '',
        File_Type: ''
      }
      this.computedAmountSpent = null
      this.details = null
    }
  }
}
</script>
<style>
.inputAmount input[type='number'] {
    -moz-appearance:textfield;
}
.inputAmount input::-webkit-outer-spin-button,
.inputAmount input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>
